import { LevelFilter, SearchOrder } from '../domains/the-level-filter-and-the-search-order';
import { FilterEventDto } from '@smatchy/sdk';
import { GeoPosition } from '../../locations/domains/geo-position';
import { GeoLocality } from '../../locations/domains/geo-locality';

export class SetLoadingEventsAction {
  static readonly type = '[FilterEvents] SetLoadingEventsAction';

  constructor(public loading: boolean) {}
}

export class SearchEventsAction {
  static readonly type = '[FilterEvents] Add item';

  constructor(public payload: string) {}
}

export class loadExploreEventsActionFromFilter {
  static readonly type = '[FilterEvents] loadExploreEventsActionFromFilter';
}

export class LoadExploreEventsAction {
  static readonly type = '[FilterEvents] LoadExploreEventsAction';
}

export class LoadExploreEventsActionWithoutMe {
  static readonly type = '[FilterEvents] LoadExploreEventsActionWithoutMe';
}

export class UpdateRadiusExploreAction {
  static readonly type = '[FilterEvents] UpdateRadiusExploreAction';

  /**
   * `chosenByPerson` says the radius came from the person (the slider, the
   * "widen" button) rather than from a default the app applied. Only a radius
   * nobody chose may be widened by the search: see
   * the-explore-radius-widens-only-when-nobody-chose-it.ts. False by default,
   * because most callers are the app resetting its own default.
   */
  constructor(public payload: number, public readonly skipSearch = false, public readonly chosenByPerson = false) {}
}

export type FilterDateTypeExplore = 'today' | 'tomorrow' | 'week' | 'week-end' | 'all';

export class FilterByDateExploreEventsAction {
  static readonly type = '[FilterEvents] FilterByDateExploreEventsAction';

  constructor(public dateType: FilterDateTypeExplore | null) {}
}

export class ResetByDateExploreEventsAction {
  static readonly type = '[FilterEvents] ResetByDateExploreEventsAction';
}

export class FilterBySpecificDateExploreEventsAction {
  static readonly type = '[FilterEvents] FilterBySpecificDateExploreEventsAction';

  constructor(public date: Date) {}
}

/**
 * A stretch of days, which is what the calendar answers since SMA-93.
 *
 * It replaces FilterBySpecificDateExploreEventsAction rather than sitting
 * beside it: one day is a range whose two ends are the same day, so a second
 * action for that case would be two ways of saying the same thing, and the
 * screen would have to choose between them on every tap.
 */
export class FilterByDateRangeExploreEventsAction {
  static readonly type = '[FilterEvents] FilterByDateRangeExploreEventsAction';

  constructor(public start: Date, public end: Date) {}
}

export class FilterExploreEventsAction {
  static readonly type = '[FilterEvents] FilterExploreEventsAction';

  constructor(public filter: FilterEventDto) {}
}

export class SendFilterEventsAction {
  static readonly type = '[FilterEvents] SendFilterEventsAction';
}

export class AddSportSelectedToFilterEventsAction {
  static readonly type = '[FilterEvents] AddSportSelectedToFilterEventsAction';

  constructor(public sportId: string, public resetOther = false) {}
}

export class RemoveSportSelectedToFilterEventsAction {
  static readonly type = '[FilterEvents] RemoveSportSelectedToFilterEventsAction';

  constructor(public sportId: string) {}
}

export class ResetFilterEventsAction {
  static readonly type = '[FilterEvents] ResetFilterEventsAction';
}

export class FilterByDateExploreAction {
  static readonly type = '[FilterEvents] FilterByDateExploreAction';

  constructor(public dateType: FilterDateTypeExplore) {}
}

export class SetDurationFiltersEventAction {
  static readonly type = '[FilterEvents] SetDurationFiltersEventAction';

  constructor(public readonly payload: { min: number; max: number }) {}
}

export class SetDistanceFiltersEventAction {
  static readonly type = '[FilterEvents] SetDistanceFiltersEventAction';

  constructor(public readonly payload: { min: number; max: number }) {}
}

export class SetLocationFilterEventsAction {
  static readonly type = '[FilterEvents] SetLocationFilterEventsAction';

  constructor(
    public readonly payload: {
      position?: GeoPosition;
      /*
       * Optional, like the position beside it: the explore screen dispatches this
       * with whatever the profile holds, and a profile with no city has no
       * locality to give. The handler already reads it with `?.`.
       */
      locality?: GeoLocality;
    },
  ) {}
}

/**
 * The « Niveau » and « Trier par » blocks of the filters, sent together when
 * the person confirms the window (the-level-filter-and-the-search-order.ts).
 * Replaced the « only my level » toggle on 22/10/2026.
 */
export class SetLevelFilterEventsAction {
  static readonly type = '[FilterEvents] SetLevelFilterEventsAction';

  constructor(
    public readonly payload: {
      levelFilter: LevelFilter;
      keepAnyLevel: boolean;
      searchOrder: SearchOrder;
    },
  ) {}
}

export class SetHandiFriendlyOnlyFilterEventsAction {
  static readonly type = '[FilterEvents] SetHandiFriendlyOnlyFilterEventsAction';

  constructor(public readonly payload: boolean) {}
}

/** The « Partenaires » link of the explore page: only brand partner events. */
export class SetPartnersOnlyFilterEventsAction {
  static readonly type = '[FilterEvents] SetPartnersOnlyFilterEventsAction';

  constructor(public readonly payload: boolean) {}
}

export class SetFilterByDateExploreEventsAction {
  static readonly type = '[FilterEvents] SetFilterByDateExploreEventsAction';

  constructor(public dateType: FilterDateTypeExplore) {}
}
